export default __webpack_public_path__ + "static/media/survey-purple.2b12ded4.png";